<template>
  <el-dialog
    title="二级代理商信息"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="mini"
    >
      <el-row>
        <el-col :span="8">
      <el-form-item
        prop="legal"
        label="姓名"
      >
        <el-input v-model="form.legal"  :disabled="true"></el-input>
      </el-form-item>
        </el-col>
        <el-col :span="8">
      <el-form-item
        prop="userName"
        label="公司/个人"
      >
        <el-input v-model="form.userName"  :disabled="true"></el-input>
      </el-form-item>
        </el-col>
        <el-col :span="8">
      <el-form-item
        prop="mobileNo"
        label="手机"
      >
        <el-input v-model="form.mobileNo"  :disabled="true"></el-input>
      </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
      <el-form-item
              prop="prov_cd"
              label="省"
      >
        <el-select
                class="filter-item"
                v-model="form.prov_cd"
                placeholder="请选择省"
                :disabled="true"
                @change="currentSel(form.prov_cd)"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
        </el-col>
        <el-col :span="8">
      <el-form-item
              prop="city"
              label="市"
      >
        <el-select
                class="filter-item"
                v-model="form.city"
                placeholder="请选择市"
                :disabled="true"
                @change="currentSel2(form.city)"
        >
          <el-option
                  v-for="item in typeOptions2"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
        </el-col>
        <el-col :span="8">
      <el-form-item
              prop="areaid"
              label="区"
      >
        <el-select
                class="filter-item"
                v-model="form.areaid"
                :disabled="true"
                placeholder="请选择区"
        >
          <el-option
                  v-for="item in typeOptions3"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
      <el-form-item
              prop="compaddress"
              label="地址"
      >
        <el-input v-model="form.compaddress"  :disabled="true"></el-input>
      </el-form-item>
        </el-col>
        <el-col :span="8">
      <el-form-item
              prop="contractstdate"
              label="合同开始日期"
      >

        <el-date-picker
                v-model="form.contractstdate"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd"  :disabled="true">
        </el-date-picker>

      </el-form-item>
        </el-col>
        <el-col :span="8">
      <el-form-item
              prop="contractendate"
              label="合同结束日期"
      >
        <el-date-picker
                v-model="form.contractendate"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd"  :disabled="true">
        </el-date-picker>
      </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 300px;">
      <el-tab-pane label="服务商" name="third">
        <child3 v-if="isChildUpdate3"  :agentid_f3="agentid_f3" :xt_id_f3="xt_id_f3" :dl_type_f3="dl_type_f3"></child3>
      </el-tab-pane>
      <el-tab-pane label="商户列表" name="fourth">
        <child4 v-if="isChildUpdate4" :agentid_f4="agentid_f4" :xt_id_f4="xt_id_f4" :dl_type_f4="dl_type_f4"></child4>
      </el-tab-pane>
    </el-tabs>

  </el-dialog>

</template>
<style>
  .customWidth{
    width:80%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
    import tabZujianChild1 from '@/pages/sys/oneagent/tabZujianChild1'
    import tabZujianChild2 from '@/pages/sys/oneagent/tabZujianChild2'
    import tabZujianChild3 from '@/pages/sys/oneagent/tabZujianChild3'
    import tabZujianChild4 from '@/pages/sys/oneagent/tabZujianChild4'
export default {
  name: "twoagentdEditForm",
    components:{
        child3:tabZujianChild3,
        child4:tabZujianChild4
    },
  props: {
      oneagent: Object,
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
        activeName:'third',
        pickerOptions: {}, // 日期设置对象
        isChildUpdate3:true,
        isChildUpdate4:false,
        xt_id_f3:"",
        agentid_f3:"",
        dl_type_f3:"",

        xt_id_f4:"",
        agentid_f4:"",
        dl_type_f4:"",
      form: {
      legal: "",
          userName: "",
          mobileNo: "",
          compaddress: "",
          contractstdate: "",
          contractendate: ""
      },
        typeOptions: [],
        typeOptions2: [],
        typeOptions3: []
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
        this.xt_id_f3=this.oneagent.xt_id;
        this.agentid_f3=this.oneagent.agentid;
        this.dl_type_f3=this.oneagent.dl_type;


        this.xt_id_f4=this.oneagent.xt_id;
        this.agentid_f4=this.oneagent.agentid;
        this.dl_type_f4=this.oneagent.dl_type;
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
        var formData2 = new FormData() // 声明一个FormData对象
        agentService.getProvcd(formData2).then(data => {
            this.typeOptions=data;
        });
        if(this.oneagent.city){
            this.currentSel(this.oneagent.prov_cd);
        }
        if(this.oneagent.areaid){
            this.currentSel2(this.oneagent.city);
        }
      if (this.oneagent.userId) {
       // userService.getUser(this.user.id).then(data => {
          let form = {};
          form.legal = this.oneagent.legal;
          form.userName = this.oneagent.agentname;
          form.mobileNo = this.oneagent.mobileNo;
          form.prov_cd = this.oneagent.prov_cd;
          form.city = this.oneagent.city;
          form.areaid = this.oneagent.areaid;
          form.compaddress = this.oneagent.compaddress;
          form.contractstdate = this.oneagent.contractstdate;
          form.contractendate = this.oneagent.contractendate;
          this.form = form;
       // });
      } else {
        this.form = {};
      }
    },
      handleClick(tab, event) {
          console.log(tab, event);
        if(tab.name == 'third'){
              // 触发‘用户管理’事件
              this.isChildUpdate3 = true;
              this.isChildUpdate4 = false;
          }else if(tab.name == 'fourth'){
              // 触发‘用户管理’事件
              this.isChildUpdate3 = false;
              this.isChildUpdate4 = true;
          }
      },
      currentSel(val) {
          if (this.oneagent.userId) {
              this.form.city = "";
              this.form.areaid = "";
          }
          this.typeOptions2=[];
          var formData2 = new FormData() // 声明一个FormData对象

          formData2.append('type','city')
          formData2.append('areaid',val)
          agentService.getProvcd(formData2).then(data => {
              this.typeOptions2=data;
          });
      },
      currentSel2(val) {
          this.typeOptions3=[];
          var formData2 = new FormData() // 声明一个FormData对象
          formData2.append('type','area')
          formData2.append('areaid',val)
          agentService.getProvcd(formData2).then(data => {
              this.typeOptions3=data;
          });
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

